<div>
  <div *ngIf="doneForNow">
    <div class="description description__title vc-text-m" i18n="@@GET_PAID.REASSURANCE.DONE_FOR_NOW.TITLE">
      You are done for now
    </div>
    <div class="description description__text vc-text-m" i18n="@@GET_PAID.REASSURANCE.DONE_FOR_NOW.DESCRIPTION">
      Thank you for uploading the requested informations, you are done for now, we might need some additional
      informations in the future.
    </div>
  </div>

  <div *ngIf="allDone">
    <div class="description description__title vc-text-m" i18n="@@GET_PAID.REASSURANCE.ALL_DONE.TITLE">
      You are all done
    </div>
    <div class="description description__text vc-text-m" i18n="@@GET_PAID.REASSURANCE.ALL_DONE.REGARDS">
      Congrats! you are all set to experiment our new payment system.
    </div>
  </div>
</div>
